import React from 'react';

interface Props {
  items: string[];
  listClass?: string;
  listTitle?: string;
}

const List = ({ items, listClass = '', listTitle }: Props) => {
  return (
    <>
      {listTitle && <h6 className="list-title medium-bold">{listTitle}</h6>}
      <ul className={`list ${listClass}`}>
        {items.map((value) => (
          <li key={value} className="list-item">
            {value}
          </li>
        ))}
      </ul>
    </>
  );
};

export default List;
